import { OCPI_BOOKING } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  ocpiPartnerChargingReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const ocpiPartnerChargingReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case OCPI_BOOKING.REQUEST: {
      return { ...state, isLoading: true };
    }
    case OCPI_BOOKING.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ocpiPartnerChargingReport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case OCPI_BOOKING.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default ocpiPartnerChargingReportReducer;
